import type { CSSProperties } from "react";

export function Icon({
  name,
  style,
  className,
}: {
  name: string;
  style?: CSSProperties;
  className?: string;
}) {
  return (
    <span
      className={`material-symbols-rounded${className ? ` ${className}` : ""}`}
      style={style}
      aria-hidden
    >
      {name}
    </span>
  );
}
